import type { FormDataOf } from '../../../../../types/templates';
import { disneyEspnVS } from '..';
import { getMatchesForLeague } from './get-matches-for-league';
import { LEAGUE_CONFIGS } from './league-config';

type FormData = FormDataOf<typeof disneyEspnVS>;

// Looks up the full match record for the currently selected league/teams.
// Also infers league/sport from creativityType when the form doesn't carry them
// (used by miniaturas).
export const getMatchData = (formData: FormData, creativityType?: string) => {
  const { sport: formSport, league: formLeague, round, team1, team2 } = formData;

  const league = formLeague || creativityType?.split('/')[3];
  if (!league || !LEAGUE_CONFIGS[league]) return null;

  const config = LEAGUE_CONFIGS[league];

  const isMiniatura = creativityType?.includes('miniatura');
  const sport = formSport || (isMiniatura ? config.sport : undefined);
  if (sport !== config.sport) return null;

  const matches = getMatchesForLeague(config.sport, league);
  if (!matches || matches.length === 0) return null;

  const filteredMatches = config.requiresRound && round ? matches.filter(m => m.round === round) : matches;
  return filteredMatches.find(m => m.team1 === team1 && m.team2 === team2) ?? null;
};
